import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Container } from 'react-bootstrap'

import { 
    Home,
    Clientes,
    Contato,
    Filosofia,
    Institucional,
    Noticias,
    Obras,
    Segmentos,
    HomeTemp
} from './../containers'

import { Header, Footer } from './../components'

const Routes = () => {
    return(
        <Router>
            <Header/>
            <Container fluid className='px-0 flex-grow-1' >
                <Switch>
                    {/* <Route exact path='/' component={HomeTemp}/> */}
                    {/* <Route path='/temp' component={Home}/> */}
                    <Route path='/' exact component={Home}/>
                    <Route path='/Clientes' component={Clientes}/>
                    <Route path='/Contato' component={Contato}/>
                    <Route path='/Filosofia' component={Filosofia}/>
                    <Route path='/Institucional' component={Institucional}/>
                    <Route path='/Noticias' component={Noticias}/>
                    <Route path='/Obras' component={Obras}/>
                    <Route path='/Segmentos' component={Segmentos}/>
                </Switch>
            </Container>
            <Footer/>
        </Router>
    )
}

export default Routes